import { Typography } from '@mui/joy';
import React from 'react';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Button from '@mui/joy/Button';

function UserConsentDialog(props) {

    const onButtonClick = (response) => {
        props.handleConsentCallback(response);
    }

    // const Transition = React.forwardRef(function Transition(props, ref) {
    //     return <Slide direction="up" ref={ref} {...props} />;
    // });

    return (
        <Modal
            keepMounted open={props.show} onClose={props.onHide}
            slotProps={{
                backdrop: {
                    sx: {
                        opacity: props.show ? 1 : 0,
                        backdropFilter: props.show ? 'blur(8px)' : 'none',
                        transition: 'opacity 400ms, backdrop-filter 400ms',
                    }
                }
            }}
            sx={{ visibility: props.show ? 'visible' : 'hidden' }}
            disableScrollLock={true}
        >
            <ModalDialog sx={{
                opacity: props.show ? 1 : 0, transition: 'opacity 300ms',
                minWidth: 'min(95vw, 490px)', maxWidth: 'min(95vw, 1080px)', width: 'auto',
                maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column',
            }}>
                <DialogTitle>Use of personal information</DialogTitle>

                <DialogContent sx={{ m: 2 }}>

                    <Typography level='body-sm' variant="plain">As a part Lambton College’s commitment to Equity, Diversity, and Inclusion (EDI), we collect certain data from students at the point of application to the college. This data helps us to better understand the diverse backgrounds of students and to ensure equitable policies, programs, and services.
                    </Typography>

                    <Typography level='body-sm' variant="plain">The data we collect includes demographic information such as ethnicity, religion and/or spiritual self-identity, sexual orientation, disability, and military-connected status. We understand that this information is personal and sensitive, and we take the responsibility of collecting and using it very seriously. All information collected is kept confidential and will be used solely for the purposes of improving our programs and services and furthering our commitment to EDI within our institution.
                    </Typography>
                    <Typography level='body-sm' variant="plain">Personal information provided will be collected, protected, used, disclosed, and retained in compliance with Ontario’s Freedom of Information and Protection of Privacy Act and Lambton College’s Confidentiality and Privacy of Information and Records Policy and Data Assurance Policy.
                        <br></br><br></br><b> If you have any concerns or questions about the collection and use of this data, please do not hesitate to contact Patrick Bennett, Director, Institutional Intelligence & College Registrar at Patrick.bennett@lambtoncollege.ca</b>
                    </Typography>

                </DialogContent>
                <DialogActions>
                    <Button size='sm' variant='solid' onClick={() => { onButtonClick(true) }}>Agree</Button>
                    <Button size='sm' variant='soft' onClick={() => { onButtonClick(false) }}>Disagree</Button>
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}
export default UserConsentDialog;